export default "__VITE_ASSET__BUFH7rgF__"